<template>
  <div id="app">
    <router-view></router-view>
    <Benefits />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Benefits from '@/components/Benefits.vue'

export default {
  components: {
    Header,
    Footer,
    Benefits
  }
}
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
